import { DccProfileDtoToEntity } from "src/app/features/DccProfile/services/mappers/DccProfileDtoToEntity";
import type { DccProfileDto } from "src/app/features/DccProfile/types/DccProfileDto";
import type { DccProfileEntity } from "src/app/features/DccProfile/types/DccProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const DccProfileTableDtoMapper = (input: Readonly<ResourcePageDto<DccProfileDto>>): ResourcePageEntity<DccProfileEntity> => {
    return {
        list: input.list ? input.list.map(DccProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
